<template>
  <div>
    <div class="mx-auto">
      <VideoScreenRecording 
        canvas-id="recordScreenAndVideoCanvasGlobalPopup" 
        :global-mode="true"
        @initialized="initialized = $event"
      />
    </div>
    <b-overlay
      id="globalVideoScreenRecordingOverlay"
      class="d-flex justify-content-center align-items-center"
      :show="!initialized"
      no-wrap
    />
  </div>
</template>
<script>

import VideoScreenRecording from "@frontend/components/modules/video-screen-recording/video-screen-recording.vue";
export default {
  name: 'GlobalVideoScreenRecordingPopup',
  components: {
    VideoScreenRecording
  },
  data() {
    return {
      broadcastChannel: null,
      initialized: false,
    };
  }
 
}
</script>
<style scoped lang="scss">

  
</style>
